import env from '../config';
import { MasterdataAService } from '../services';

export const otherwiseConfigBlock = ['$urlRouterProvider', $urlRouterProvider => { 
    $urlRouterProvider.otherwise('/app');
}];

export const html5ConfigBlock = ['$locationProvider', $locationProvider => { 
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
}];

export const themeConfigBlock = ['ThemeServiceProvider', '$animateProvider', ( ThemeServiceProvider: aboTheme.IThemeProvider, $animateProvider: any ) => { 
    ThemeServiceProvider.setLogo(<string>require('../../images/logo-white.png')); 
    ThemeServiceProvider.setLogoDark(<string>require('../../images/logo-dark.png')); 
    $animateProvider.classNameFilter(/ng-animate-enabled/);
}];

export const masterDataConfigBlock = ['MasterdataAService', ( MasterdataAService: MasterdataAService ) => {
    MasterdataAService.setType('Skills', 'SKILLS');
    MasterdataAService.setType('Functions', 'Functions');
    MasterdataAService.setType('Hour codes', 'HourCodes');
    MasterdataAService.setType('Availability status', 'AvalabilityStatus');
    MasterdataAService.setType('Transportation type', 'TransportationType');
    MasterdataAService.setType('Note Tags', 'NoteTags');
    MasterdataAService.setType('Contact Tags', 'ContactTags');
    MasterdataAService.setType('Task Status', 'TaskStatus');
    MasterdataAService.setType('Preferred target audience', 'PreferredTargetAudience');
    MasterdataAService.setType('Application status', 'ApplicationStatus');
    MasterdataAService.setApiItemName('masterdata');
}];

export const config = ['RestangularProvider', 'localStorageServiceProvider', (
    RestangularProvider: Restangular.IProvider,
    localStorageServiceProvider: ng.local.storage.ILocalStorageServiceProvider
) => {

    RestangularProvider.setBaseUrl(env.API_URL);
    localStorageServiceProvider.setStorageType('sessionStorage');

}];


// WEBPACK FOOTER //
// ./src/app/main/app.config.ts